import { FormControlLabel, RadioGroup as MuiRadioGroup, Radio } from '@mui/material';
import React from 'react';
import { RadioGroupStyles } from './RadioGroup.styles';
export const RadioGroup = (props) => {
    const { options, value, onChange } = props;
    return (React.createElement(MuiRadioGroup, { defaultValue: options[0].value, value: value, onChange: (_, newValue) => onChange(newValue), row: true }, options.map((option) => (React.createElement(FormControlLabel, { key: option.value, value: option.value, control: React.createElement(Radio, { size: "small" }), label: option.label, classes: { label: RadioGroupStyles.label } })))));
};
//# sourceMappingURL=RadioGroup.js.map